import { render, staticRenderFns } from "./ProjectConfigurationParticipants.vue?vue&type=template&id=c06f99a8&"
import script from "./ProjectConfigurationParticipants.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports